import TvContent from './src/main.vue'
export default TvContent



// WEBPACK FOOTER //
// ./src/views/tv/modules/Content/index.js